import { render, staticRenderFns } from "./productSjList.vue?vue&type=template&id=46b929c7&scoped=true"
import script from "./productSjList.vue?vue&type=script&lang=js"
export * from "./productSjList.vue?vue&type=script&lang=js"
import style0 from "./productSjList.vue?vue&type=style&index=0&id=46b929c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b929c7",
  null
  
)

export default component.exports